// extracted by mini-css-extract-plugin
export var productImage = "_mu-0";